<div class="bloco-card">
  <h3 class="bloco-title bloco-title--solo">Status da Rede</h3>

  <ng-container *ngIf="!loading; else skeleton">
    <div class="secoes-row">
      <div class="secao">
        <div class="secao-header">
          <mat-icon class="secao-icone secao-icone--update">update</mat-icon>
          <span class="secao-label">ATUALIZAÇÕES NOS ÚLTIMOS 7 DIAS</span>
        </div>
        <ul class="secao-lista">
          <li *ngFor="let item of atualizacoesRelevantes">
            <span class="destaque">{{ item.total }} novas obras no módulo {{ item.descricao }}</span> 
          </li>
          <li *ngIf="atualizacoesRelevantes.length === 0" class="empty">
            Nenhuma atualização encontrada.
          </li>
        </ul>
      </div>

      <div class="secao">
        <div class="secao-header">
          <mat-icon class="secao-icone secao-icone--warning">warning</mat-icon>
          <span class="secao-label">PONTOS DE ATENÇÃO</span>
        </div>
        <div class="atencao-item">
          <span class="atencao-num">{{ obrasSemInteracao }}</span>
          <span class="atencao-texto">Obras sem interação há mais de 10 dias</span>
        </div>
        <div class="atencao-item">
          <span class="atencao-num">{{ tarefasAtrasadas }}</span>
          <span class="atencao-texto">Tarefas atrasadas</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #skeleton>
    <div class="secoes-row">
      <div class="secao">
        <div class="skeleton-header"></div>
        <div class="skeleton-lista">
          <div class="skeleton-item" *ngFor="let i of [1,2,3]"></div>
        </div>
      </div>
      <div class="secao">
        <div class="skeleton-header"></div>
        <div class="skeleton-atencao-item" *ngFor="let i of [1,2]"></div>
      </div>
    </div>
  </ng-template>
</div>